import React from 'react';
import ci from 'static/images/logo/logo.png';

const Logo = () => {
  const style = {
    width: `30%`,
    marginLeft: `2%`,
  };
  return (
    <div className="headerLogo">
      <img style={style} src={ci} alt="ci" />
    </div>
  );
};

export default Logo;
